/* Ivande, Threshold homepage
   Hero nightscape placeholder (used until real footage is set) and
   reveal-on-scroll. All scoped to the .ivth root; no-ops gracefully
   when a hero video is present. */
(function () {
  'use strict';
  var root = document.querySelector('.ivth');
  if (!root) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // reveal on scroll
  var rises = root.querySelectorAll('.ivth-rise');
  if (!reduce && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    rises.forEach(function (el) { io.observe(el); });
  } else {
    rises.forEach(function (el) { el.classList.add('in'); });
  }

  // iOS Safari does not blend mix-blend-mode over <video>; hide the
  // tag-wall videos there so the gradient base layer shows through
  // the letterforms instead of an opaque white cover.
  var isIOS = /iP(hone|ad|od)/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (isIOS) root.classList.add('ivth--no-video-blend');

  // Safari does not reliably apply clip-path: url(#...) to HTML
  // elements, and WORSE: recent iOS versions pass a hit-test probe
  // while still painting the clip empty (confirmed on iPhone 14 Pro
  // Max and 17 Pro; iPhone 12 failed the probe and worked via the
  // fallback). Feature detection cannot catch a browser that lies,
  // so every WebKit engine gets the straight-line shard fallback
  // unconditionally: all iOS browsers (they must use WebKit) and
  // desktop Safari.
  var isWebKitEngine = isIOS ||
    (/AppleWebKit/.test(navigator.userAgent) && !/Chrome|CriOS|EdgiOS|FxiOS|Android/.test(navigator.userAgent));
  if (isWebKitEngine) {
    root.classList.add('ivth--no-svg-clip');
  } else {
    // Non-WebKit engines: geometric probe as a safety net. A point
    // the shard-1 path cuts away must MISS, and a point inside the
    // shape must HIT. display:block is inline because base.css hides
    // empty divs, which would blind the probe entirely.
    (function () {
      if (!root.querySelector('.ivth-clip') || !document.getElementById('ivth-shard-1')) return;
      var probe = document.createElement('div');
      probe.style.cssText = 'display:block;position:fixed;left:0;top:0;width:100px;height:100px;opacity:0;pointer-events:auto;z-index:2147483647;clip-path:url(#ivth-shard-1);-webkit-clip-path:url(#ivth-shard-1);';
      document.body.appendChild(probe);
      var hitOutside = document.elementFromPoint(90, 90);
      var hitInside = document.elementFromPoint(30, 90);
      if (hitOutside === probe || hitInside !== probe) root.classList.add('ivth--no-svg-clip');
      probe.remove();
    })();
  }

  // film-shard two-clip chains: play A to the end, swap to B, repeat
  root.querySelectorAll('[data-ivth-clip-cycle]').forEach(function (clip) {
    var vids = clip.querySelectorAll('video');
    if (vids.length < 2) return;
    vids.forEach(function (v, i) {
      v.loop = false;
      v.muted = true;
      v.addEventListener('ended', function () {
        var next = vids[(i + 1) % vids.length];
        v.classList.remove('is-on');
        next.classList.add('is-on');
        try { next.currentTime = 0; } catch (err) { /* not seekable yet */ }
        var p = next.play();
        if (p && p.catch) p.catch(function () {});
      });
    });
  });

  // Pause any video whose host scrolls out of view (battery, decode
  // budget on phones, and chain videos must not "end" unseen); resume
  // the active one on re-entry.
  if ('IntersectionObserver' in window) {
    var vidHosts = root.querySelectorAll('.ivth-clip, .ivth-tag-media, .ivth-filmbox');
    if (vidHosts.length) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          e.target.querySelectorAll('video').forEach(function (v) {
            var isActive = v.classList.contains('is-on') || !v.closest('.ivth-clip, .ivth-tag-media');
            if (e.isIntersecting && isActive) {
              var p = v.play();
              if (p && p.catch) p.catch(function () {});
            } else if (!e.isIntersecting) {
              v.pause();
            }
          });
        });
      }, { threshold: 0, rootMargin: '30% 0px' });
      vidHosts.forEach(function (h) { vio.observe(h); });
    }
  }

  // Craft column parallax (phones): each still drifts at its own
  // rate inside its curved cut, so the fused column reads as one
  // moving length of cloth. The CSS pre-scales the images to give
  // the drift headroom; drift is clamped inside that headroom.
  (function () {
    var phone = window.matchMedia('(max-width: 767px)');
    var frames = root.querySelectorAll('.ivth-trio-img img');
    if (!frames.length || reduce) return;
    var rates = [0.06, 0.1, 0.06];
    var running = false, queued = false;

    function drift() {
      queued = false;
      if (!phone.matches) return;
      var mid = window.innerHeight / 2;
      frames.forEach(function (img, i) {
        var r = img.parentElement.getBoundingClientRect();
        var d = (mid - (r.top + r.height / 2)) * (rates[i] || 0.06);
        d = Math.max(-30, Math.min(30, d));
        img.style.setProperty('--ivth-drift', d.toFixed(1) + 'px');
      });
    }
    function onScroll() {
      if (!running || queued) return;
      queued = true;
      requestAnimationFrame(drift);
    }
    if ('IntersectionObserver' in window) {
      var trio = root.querySelector('.ivth-trio');
      new IntersectionObserver(function (entries) {
        running = entries[0].isIntersecting;
        if (running) onScroll();
      }, { rootMargin: '20% 0px' }).observe(trio);
    } else {
      running = true;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    drift();
  })();

  // In-app browsers (Instagram, TikTok, Facebook) often refuse video
  // autoplay until the first user gesture, and some drop the HTML
  // muted state, which then blocks play() forever. Force the muted
  // and inline properties, try to start whatever is on screen, and
  // retry once on the first touch, scroll, or tap.
  (function () {
    var vids = root.querySelectorAll('.ivth-clip video, .ivth-filmbox video');
    if (!vids.length) return;
    function kick() {
      vids.forEach(function (v) {
        v.muted = true;
        v.playsInline = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        var inChain = v.closest('[data-ivth-clip-cycle]');
        if (inChain && !v.classList.contains('is-on')) return;
        var r = v.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        if (v.paused) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        }
      });
    }
    kick();
    var opts = { once: true, passive: true };
    ['touchstart', 'scroll', 'click'].forEach(function (evt) {
      window.addEventListener(evt, kick, opts);
    });
  })();

  // hero nightscape placeholder, only when no <video> was rendered
  var scene = root.querySelector('[data-ivth-scene]');
  if (!scene) return;

  var warm = ['#B8431F', '#B59429', '#F4EFE3', '#D8A94A', '#C9633A'];
  var stars = root.querySelector('[data-ivth-stars]');
  if (stars) {
    for (var i = 0; i < 46; i++) {
      var st = document.createElement('span'); st.className = 'ivth-star';
      st.style.left = (Math.random() * 100).toFixed(2) + '%';
      st.style.top = (Math.random() * 100).toFixed(2) + '%';
      st.style.setProperty('--d', (2.5 + Math.random() * 4).toFixed(2) + 's');
      st.style.setProperty('--dl', (Math.random() * 4).toFixed(2) + 's');
      if (Math.random() > 0.72) { st.style.width = st.style.height = '1px'; }
      if (reduce) st.style.animation = 'none';
      stars.appendChild(st);
    }
  }

  function buildSkyline(el, o) {
    if (!el) return;
    var total = 0;
    while (total < 104) {
      var w = o.wmin + Math.random() * (o.wmax - o.wmin);
      var h = o.hmin + Math.random() * (o.hmax - o.hmin);
      total += w;
      var b = document.createElement('div'); b.className = 'ivth-bldg';
      b.style.width = w + '%'; b.style.height = h + '%'; b.style.background = o.color;
      var cols = Math.max(2, Math.round(w / o.step));
      var rows = Math.max(3, Math.round(h / o.stepV));
      for (var r = 0; r < rows; r++) {
        for (var c = 0; c < cols; c++) {
          if (Math.random() > o.lit) continue;
          var win = document.createElement('span'); win.className = 'ivth-win';
          win.style.width = o.w + 'px'; win.style.height = o.h + 'px';
          win.style.left = 'calc(' + (((c + 0.5) / cols) * 100).toFixed(1) + '% - ' + (o.w / 2) + 'px)';
          win.style.bottom = (((r + 0.55) / rows) * 100).toFixed(1) + '%';
          var col = warm[Math.floor(Math.random() * warm.length)];
          win.style.background = col; win.style.boxShadow = '0 0 4px ' + col;
          win.style.setProperty('--wo', (0.5 + Math.random() * 0.5).toFixed(2));
          if (!reduce && Math.random() > 0.4) {
            win.style.setProperty('--wd', (3 + Math.random() * 6).toFixed(2) + 's');
            win.style.setProperty('--wdl', (Math.random() * 6).toFixed(2) + 's');
          } else { win.style.animation = 'none'; }
          b.appendChild(win);
        }
      }
      el.appendChild(b);
    }
  }
  buildSkyline(root.querySelector('[data-ivth-sky="far"]'),  { wmin: 4, wmax: 8,  hmin: 38, hmax: 72,  color: '#15252b', step: 2.2, stepV: 9,   w: 2, h: 3, lit: 0.26 });
  buildSkyline(root.querySelector('[data-ivth-sky="mid"]'),  { wmin: 5, wmax: 10, hmin: 44, hmax: 90,  color: '#0e1c21', step: 2.6, stepV: 8,   w: 3, h: 4, lit: 0.32 });
  buildSkyline(root.querySelector('[data-ivth-sky="near"]'), { wmin: 6, wmax: 12, hmin: 52, hmax: 100, color: '#081215', step: 3,   stepV: 7.5, w: 3, h: 5, lit: 0.36 });
})();

/* Duo rotation: both stills cycle the catalogue, cell two one slide
   ahead, advancing together every few seconds; paused offscreen and
   entirely static under reduced motion. */
(function () {
  var duo = document.querySelector('[data-ivth-duo-rotate]');
  if (!duo) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var cells = Array.prototype.slice.call(duo.querySelectorAll('.ivth-duo-cell'));
  var counts = cells.map(function (c) { return c.querySelectorAll('.ivth-duo-slide').length; });
  if (!counts[0] || counts[0] < 2) return;
  var tick = 0;
  var visible = true;
  function advance() {
    if (!visible) return;
    tick += 1;
    cells.forEach(function (cell, ci) {
      var slides = cell.querySelectorAll('.ivth-duo-slide');
      var start = parseInt(cell.dataset.duoStart || ci, 10);
      slides.forEach(function (s, si) {
        s.classList.toggle('is-on', si === (start + tick) % slides.length);
      });
    });
  }
  setInterval(advance, 4500);
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
    }, { rootMargin: '10% 0px' }).observe(duo);
  }
})();
